//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../no/GeometricUtilities.js";
import "../no/Expression.js";
let d=[[[1,"AddendumFactor",0,"Expression",0],[1,"AddendumModCoefficient",0,"Expression",0],[0,"AssociativeAxis",1,0],[0,"Axis",1,"Axis",0],[1,"BaseHeight",0,"Expression",0],[1,"BooleanOperation",0,"GeometricUtilities.BooleanOperation",0],[1,"Clearance",0,"Expression",0],[1,"FaceWidth",0,"Expression",0],[1,"FilletRadiusFactor",0,"Expression",0],[0,"HandednessOfHelix",1,0],[1,"HelixAngle",0,"Expression",0],[1,"Length",0,"Expression",0],[1,"Module",0,"Expression",0],[0,"ParameterType",1,0],[1,"Pitch",0,"Expression",0],[1,"PressureAngle",0,"Expression",0],[0,"Type",1,0]],[],[]];
SPLM.Features.RackBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.RackBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.RackBuilder.Types = Object.freeze({
    "Spur" : "Spur", "Helical" : "Helical"});

SPLM.Features.RackBuilder.EnumParameterType = Object.freeze({
    "Module" : "Module", "Pitch" : "Pitch"});

SPLM.Features.RackBuilder.EnumHandednessOfHelixType = Object.freeze({
    "LeftHand" : "LeftHand", "RightHand" : "RightHand"});

export default SPLM;